/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as IdentityDefs from './defs.defs.js'

const $nsid = 'com.atproto.identity.resolveIdentity'

export { $nsid }

/** Resolves an identity (DID or Handle) to a full identity (DID document and verified handle). */
const main = l.query(
  $nsid,
  l.params({ identifier: l.string({ format: 'at-identifier' }) }),
  l.payload(
    'application/json',
    l.ref<IdentityDefs.IdentityInfo>((() => IdentityDefs.identityInfo) as any),
  ),
  ['HandleNotFound', 'DidNotFound', 'DidDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
